// TES-1383 — what the open meeting view says when the meeting it shows is no
// longer on. On 2026-10-15 the patient moved her 10:00 meeting at 09:54; the
// doctor, who had the meeting open since 09:48, pressed "Anslut" at 10:00 and
// read "Mötet har redan avslutats". The view now re-reads the meeting's status
// and says what happened instead.
//
// Pure on purpose: no React, no path aliases, so `node --test` runs it.
import type { MeetingLiveStatus } from "@care-by-ella/contracts";
import { patientHref } from "./patient-links";

export interface MeetingGoneNotice {
  text: string;
  // The new meeting, when it was moved.
  link: { href: string; label: string } | null;
}

/** "tis 3 nov. 09:00" — weekday, date and time in the clinic's zone. */
export function meetingWhen(iso: string): string {
  return new Date(iso).toLocaleString("sv-SE", {
    timeZone: "Europe/Stockholm",
    weekday: "short",
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** Null while the meeting is not cancelled. */
export function meetingGoneNotice(
  status: MeetingLiveStatus,
): MeetingGoneNotice | null {
  if (status.status !== "cancelled") return null;
  const moved = status.rescheduledTo;
  if (moved) {
    return {
      text: `Patienten har bokat om mötet till ${meetingWhen(moved.scheduledAt)}.`,
      link: {
        href: patientHref(moved.patientId, "moten", moved.id),
        label: "Öppna det nya mötet",
      },
    };
  }
  return {
    text:
      status.cancelledBy === "patient"
        ? "Patienten har avbokat mötet."
        : "Mötet är avbokat.",
    link: null,
  };
}
